export default Object.freeze({
  Text: 1,
  Select: 3,
  Date: 4,
  Number: 5,
  Boolean: 6,
})
